import React, { useContext } from 'react'

import type { RecipeGridContentBlock } from '@library/api-menu-experience'
import { RecipeGrid } from '@library/menu-page'
import type { RecipeUUID } from '@library/menu-service'

import { MenuBrandingContext } from '../menuBrandingContext'
import { useMenuExperienceRecipeDetails } from '../menuExperienceRecipeDetailContext'

type RecipeGridContentBlockWrapperProps = {
  contentBlock: RecipeGridContentBlock
}

const onAddClick = () => {}
const onRemoveClick = () => {}
const onBlockedAddAttempt = () => {}
const getRecipeTileState = () => ({
  isInBasket: false,
  canAddRecipes: true,
  reachedLimit: false,
})

export const RecipeGridContentBlockWrapper = ({
  contentBlock,
}: RecipeGridContentBlockWrapperProps) => {
  const { textColor } = useContext(MenuBrandingContext)
  const { openRecipeDetail } = useMenuExperienceRecipeDetails()

  const onRecipeClick = (recipeId: RecipeUUID, recipePosition: number) => {
    const recipe = contentBlock.items.find((item) => item.id === recipeId)

    if (!recipe) {
      return
    }

    openRecipeDetail({
      recipeId,
      title: recipe.title,
      position: recipePosition.toString(),
      source: 'recipe_grid',
    })
  }

  return (
    <RecipeGrid
      contentBlock={contentBlock}
      recipeCountTextColor={textColor}
      getRecipeTileState={getRecipeTileState}
      onRecipeClick={onRecipeClick}
      onAddClick={onAddClick}
      onRemoveClick={onRemoveClick}
      onBlockedAddAttempt={onBlockedAddAttempt}
    />
  )
}
